export default __webpack_public_path__ + "static/media/family_primary.68904133.png";